<template>
  <div class="canvas-wrapper">
    <div class="canvas-holder">
      <canvas
        ref="canvasRef"
        class="canvas"
      />
    </div>
    <div class="controls">
      <div
        v-if="canvasData"
        class="clear-icon icon"
        @click="clearCanvas"
      >
        <img src="@/assets/close_gray.svg">
      </div>
      <div
        :class="{disabled: !canvasData}"
        class="next-icon icon"
        @click="$emit('next')"
      >
        <img src="@/assets/play_arrow.svg">
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onBeforeUnmount, onMounted } from 'vue';
import { setOrientationChangeListener, removeOrientationChangeListener } from '@ht/lib-plural-vue';
import useCanvasInput from '@/composables/useCanvasInput';

export default defineComponent({
  name: 'CanvasInputComponent',

  emits: ['data', 'drawing', 'clear', 'next'],

  props: {
    canvasData: {
      type: String,
      required: true,
    },
  },

  setup(props, { emit }) {
    const {
      canvasRef,
      initContext,
      subscribeEvents,
      setCanvasSize,
      clearCanvas,
      CANVAS_RESIZE_TIMOUT,
    } = useCanvasInput(emit);

    function onOrientationChanged() {
      clearCanvas();
      setTimeout(setCanvasSize, CANVAS_RESIZE_TIMOUT);
    }

    onMounted(() => {
      const context = initContext();
      context.strokeStyle = '#000000';
      context.lineWidth = 3;

      subscribeEvents();
      setCanvasSize();

      setOrientationChangeListener(onOrientationChanged);
    });

    onBeforeUnmount(() => {
      removeOrientationChangeListener(onOrientationChanged);
    });

    return {
      canvasRef,
      clearCanvas,
    };
  },
});
</script>

<style lang="scss" scoped>
.canvas-wrapper {
  .canvas-holder {
    position: relative;
    width: 100%;
    overflow: hidden;
    height: clamp(100px, 30vmin, 600px);

    .canvas {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: crosshair;
    }
  }

  .controls {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: clamp(12px, 2vmin, 16px);
    padding-top: clamp(12px, 2vmin, 16px);
    border-top: 1px solid #E1E6EC;

    .icon {
      position: relative;
      cursor: pointer;
      border: 2px solid transparent;
      flex-shrink: 0;
      border-radius: 100%;
      height: clamp(38px, 6vmin, 58px);
      width: clamp(38px, 6vmin, 58px);

      &:hover:not(.disabled) {
        opacity: 0.9;
      }

      &.disabled {
        opacity: 0.5;
      }

      img {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
      }
    }

    .next-icon {
      background-color: #007CBA;
      margin-left: clamp(10px, 2vmin, 16px);
    }

    .clear-icon {
      border-color: #E1E6EC;
    }
  }
}

</style>
